<template>
    <div>
      <loading
        :active.sync="loader.isLoading"
        :can-cancel="loader.canCancel"
        :is-full-page="loader.fullPage"
        :color="loader.color"
        :height="loader.height"
        :width="loader.width"
        :background-color="loader.backgroundColor"
        :loader="loader.loader">
      </loading>
      <div class="row">
        <div class="col-md-12">
          <div class="top-list-toolbar">
            <div>
              <h4 class="text-primary">Sale Commission</h4>
              <ol class="breadcrumb breadcrumb-card-header">
                <li class="breadcrumb-item">
                  <a href="javascript:void(0);" @click="backParent">Sales</a>
                </li>
                <li class="breadcrumb-item active">
                  <span v-if="comm.id === null">New</span>
                  <span v-else>{{ comm.name }}</span>
                </li>
              </ol>
              <button type="button" @click="update" class="btn btn-sm btn-soft-primary pull-left" v-show="comm.id !== null"><i class="fa fa-save" aria-hidden="true"></i> Update</button>
              <button type="button" @click="save" class="btn btn-sm btn-soft-primary pull-left" v-show="comm.id == null"><i class="fa fa-check" aria-hidden="true"></i> Save</button>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
          <div class="card card-list">
            <div class="card-body">
              <div class="row">
                <div class="col-md-4">
                    <dl class="dl-custom row">
                        <dt class="col-md-4">&nbsp;</dt>
                        <dd class="col-md-8">
                          <label for="group_id" class="col-sm-3 col-form-label text-left">&nbsp;</label>
                          <div class="custom-control custom-checkbox">
                            <input type="checkbox" id="canBarcode" data-parsley-multiple="groups" data-parsley-mincheck="2" class="custom-control-input" v-model="comm.active">
                            <label for="canBarcode" class="custom-control-label">Active</label>
                          </div>
                        </dd>
                        <dt class="col-md-4">Name</dt>
                        <dd class="col-md-8">
                            <input type="text" class="form-control" v-model="comm.name" />
                        </dd>

                        <dt class="col-md-4">Company</dt>
                        <dd class="col-md-8">
                            <select class="form-control" v-model="comm.company_no" :disabled="comm.id !== null">
                                <option v-for="c in companyList" :key="c.id" :value="c.company_no">{{ c.name }}</option>
                            </select>
                        </dd>

                        <dt class="col-md-4">Type</dt>
                        <dd class="col-md-8">
                          <select v-model="comm.type" class="form-control" @change="getType">
                            <option value="product">Product</option>
                            <option value="salesman">Salesman</option>
                            <option value="supervisor">Supervisor</option>
                            <option value="customer">By Customer</option>
                            <option value="omzet">Omzet</option>
                          </select>
                        </dd>

                        <dt class="col-md-4">Amount</dt>
                        <dd class="col-md-8">
                          <input type="text" class="form-control" v-model="comm.amount" v-money="money" />
                        </dd>

                        <dt class="col-md-4">Notes</dt>
                        <dd class="col-md-8">
                            <textarea rows="5" v-model="comm.notes" class="form-control"></textarea>
                        </dd>
                    </dl>
                </div>
                <div class="col-md-4">
                  <dl class="dl-custom row">
                    <dt class="col-md-4">Age</dt>
                    <dd class="col-md-8">
                        <input type="text" class="form-control" v-model="comm.age" />
                    </dd>
                    <dt class="col-md-4">Percentage</dt>
                    <dd class="col-md-8">
                        <input type="text" class="form-control" v-model="comm.percentage" />
                    </dd>

                    <dt class="col-md-4">Age Limit</dt>
                    <dd class="col-md-8">
                      <input type="text" class="form-control" v-model="comm.age_limit" />
                    </dd>

                    <dt class="col-md-4">Percentage Age Limit</dt>
                    <dd class="col-md-8">
                      <input type="text" class="form-control" v-model="comm.percentage_age_limit" />
                    </dd>
                  </dl>
                </div>
                <div class="col-md-4" v-if="comm.type === 'product'">
                  <div class="table-responsive" v-if="comm.type === 'product'">
                    <table class="table table-sm table-item table-hover table-striped">
                      <thead>
                        <th>Product</th>
                        <th>#</th>
                      </thead>
                      <tbody>
                        <tr v-for="(p, index) in comm.products" :key="index">
                          <td>
                            <v-select :options="productselect" :reduce="product => product.meta.code" label="product" v-model="p.product_no"/>
                          </td>
                          <td>
                            <button type="button" class="btn btn-sm btn-outline-danger" @click="removeProduct(index)">
                              <i class="fa fa-trash"></i>
                            </button>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span @click="addNewLine" class="link-secondary" >+ Add Product</span>
                          </td>
                          <td></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="col-md-4" v-else-if="comm.type === 'omzet'">
                  <div class="table-responsive">
                    <table class="table table-sm table-item table-hover table-striped">
                      <thead>
                        <th>Amount</th>
                        <th>Amount</th>
                        <th>Fee</th>
                        <th>#</th>
                      </thead>
                      <tbody>
                        <tr v-for="(o, index) in comm.omzets" :key="index">
                          <td><input type="text" class="form-control" v-model="o.amount" v-money="money" /></td>
                          <td><input type="text" class="form-control" v-model="o.amount2" v-money="money" /></td>
                          <td><input type="text" class="form-control" v-model="o.fee" v-money="money" /></td>
                          <td>
                            <button type="button" class="btn btn-sm btn-outline-danger" @click="removeOmzet(index)">
                              <i class="fa fa-trash"></i>
                            </button>
                          </td>
                        </tr>
                        <tr>
                          <td colspan="3">
                            <span @click="addNewLineOmzet" class="link-secondary" >+ Add Fee</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="col-md-4" v-else-if="comm.type === 'customer'">
                  <div class="table-responsive">
                    <table class="table table-sm table-item table-hover table-striped">
                      <thead>
                        <th>Customer</th>
                        <th>#</th>
                      </thead>
                      <tbody>
                        <tr v-for="(p, index) in comm.customers" :key="index">
                          <td>
                            <v-select :options="customerSelect" :reduce="customer => customer.meta.code" label="customer" v-model="p.customer_no"/>
                          </td>
                          <td><button type="button" class="btn btn-sm btn-outline-danger" @click="removeCustomer(index)"><i class="fa fa-trash"></i></button></td>
                        </tr>
                        <tr>
                          <td>
                            <span @click="addCustomerLine" class="link-secondary" >+ Add Customer</span>
                          </td>
                          <td></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer">
            </div>
          </div>
      </div>
    </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import Loading from 'vue-loading-overlay'
import { getHeader, saleCommissionUrl } from '../../config'

export default {
  name: 'SaleCommissionForm',
  props: ['comm'],
  components: {
    Loading
  },
  data () {
    return {
      dataComm: [],
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: true /* doesn't work with directive */
      }
    }
  },
  computed: {
    ...mapState({
      companyList: state => state.companies.companyList,
      productListSelect: state => state.products.productListSelect,
      customerList: state => state.customers.customerList
    }),
    customerSelect () {
      var loop = []
      var array = this.customerList
      for (var x = 0; x < array.length; x++) {
        var obj = {
          customer: '[' + array[x].customer_no + '] ' + array[x].name,
          meta: {
            code: array[x].customer_no
          }
        }
        loop.push(obj)
      }
      return loop
    },
    productselect: function () {
      var loop = []
      var array = this.productListSelect
      for (var x = 0; x < array.length; x++) {
        var obj = {
          product: '[' + array[x].product_no + '] ' + array[x].product_name,
          meta: {
            code: array[x].product_no
          }
        }
        loop.push(obj)
      }
      return loop
    }
  },
  methods: {
    getType () {
      console.log('comm type: ' + this.comm.type)
      if (this.comm.type === 'salesman') {
        var array = this.comm.products
        for (let i = 0; i < array.length; i++) {
          var detail = this.comm.products[i]
          if (typeof detail.id === 'undefined') {
            this.comm.products.splice(i, 1)
          } else {
            axios.delete(saleCommissionUrl + '/product/' + detail.id, { headers: getHeader() })
              .then(response => {
              })
              .catch(error => {
                console.log(error)
                console.log(error.response)
                this.$swal('Error', error.response.data.message, 'error')
                throw error
              })
          }
        }
        this.comm.products = []
      }
    },
    async removeOmzet (index) {
      var detail = this.comm.omzets[index]
      if (typeof detail.id === 'undefined') {
        this.comm.omzets.splice(index, 1)
      } else {
        await this.$swal.fire({
          title: 'Are you sure Delete this?',
          text: "You won't be able to revert this!",
          icon: 'error',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            axios.delete(saleCommissionUrl + '/omzet/' + detail.id, { headers: getHeader() })
              .then(response => {
                console.log(response.data.message)
                this.comm.omzets.splice(index, 1)
              })
              .catch(error => {
                console.log(error)
                console.log(error.response)
                this.$swal('Error', error.response.data.message, 'error')
              })
          }
        })
      }
    },
    async removeProduct (index) {
      var detail = this.comm.products[index]
      if (typeof detail.id === 'undefined') {
        this.comm.products.splice(index, 1)
      } else {
        await this.$swal.fire({
          title: 'Are you sure Delete this?',
          text: "You won't be able to revert this!",
          icon: 'error',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            axios.delete(saleCommissionUrl + '/product/' + detail.id, { headers: getHeader() })
              .then(response => {
                console.log(response.data.message)
                this.comm.products.splice(index, 1)
              })
              .catch(error => {
                console.log(error)
                console.log(error.response)
                this.$swal('Error', error.response.data.message, 'error')
              })
          }
        })
      }
    },
    async removeCustomer (index) {
      var detail = this.comm.customers[index]
      if (typeof detail.id === 'undefined') {
        this.comm.customers.splice(index, 1)
      } else {
        await this.$swal.fire({
          title: 'Are you sure Delete this?',
          text: "You won't be able to revert this!",
          icon: 'error',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            axios.delete(saleCommissionUrl + '/customer/' + detail.id, { headers: getHeader() })
              .then(response => {
                console.log(response.data.message)
                this.comm.customers.splice(index, 1)
              })
              .catch(error => {
                console.log(error)
                console.log(error.response)
                this.$swal('Error', error.response.data.message, 'error')
              })
          }
        })
      }
    },
    addNewLineOmzet () {
      var obj = {
        amount: '0',
        amount2: '0',
        fee: '0'
      }
      this.comm.omzets.push(obj)
    },
    addCustomerLine () {
      var obj = {
        commission_id: null,
        customer_no: null,
        notes: null
      }
      this.comm.customers.push(obj)
    },
    addNewLine () {
      var obj = {
        commission_id: null,
        product_no: null,
        product: null
      }
      this.comm.products.push(obj)
    },
    backParent () {
      this.$emit('backClicked')
    },
    async save () {
      var dataOmzet = []
      var array = this.comm.omzets
      for (let i = 0; i < array.length; i++) {
        var obj = {}
        if (typeof array[i].id === 'undefined') {
          obj = {
            amount: array[i].amount.replace(/\./g, ''),
            amount2: array[i].amount2.replace(/\./g, ''),
            fee: array[i].fee.replace(/\./g, '')
          }
        } else {
          obj = {
            id: array[i].id,
            amount: array[i].amount.replace(/\./g, ''),
            amount2: array[i].amount2.replace(/\./g, ''),
            fee: array[i].fee.replace(/\./g, '')
          }
        }
        dataOmzet.push(obj)
      }
      var dataProduct = []
      var arr = this.comm.products
      for (let z = 0; z < arr.length; z++) {
        var obj2 = {}
        if (typeof arr[z].id === 'undefined') {
          obj2 = {
            commission_id: arr[z].commission_id,
            product_no: arr[z].product_no
          }
        } else {
          obj2 = {
            id: arr[z].id,
            commission_id: arr[z].commission_id,
            product_no: arr[z].product_no
          }
        }
        dataProduct.push(obj2)
      }
      var dataCustomer = []
      var arrc = this.comm.customers
      for (let a = 0; a < arrc.length; a++) {
        var obj3 = {}
        if (typeof arrc[a].id === 'undefined') {
          obj3 = {
            commission_id: arrc[a].commission_id,
            customer_no: arrc[a].customer_no,
            notes: arrc[a].notes
          }
        } else {
          obj3 = {
            id: arrc[a].id,
            commission_id: arrc[a].commission_id,
            customer_no: arrc[a].customer_no,
            notes: arrc[a].notes
          }
        }
        dataCustomer.push(obj3)
      }
      this.dataComm = {
        id: null,
        name: this.comm.name,
        amount: this.comm.amount.replace(/\./g, ''),
        percentage: this.comm.percentage,
        percentage_age_limit: this.comm.percentage_age_limit,
        age: this.comm.age,
        age_limit: this.comm.age_limit,
        company_no: this.comm.company_no,
        notes: this.comm.notes,
        type: this.comm.type,
        active: this.comm.active,
        products: dataProduct,
        omzets: dataOmzet,
        customers: dataCustomer
      }
      await axios.post(saleCommissionUrl, this.dataComm, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
          this.$swal('Success', response.data.message, 'success')
          this.backParent()
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async update () {
      var dataOmzet = []
      var array = this.comm.omzets
      for (let i = 0; i < array.length; i++) {
        var obj = {}
        if (typeof array[i].id === 'undefined') {
          obj = {
            amount: array[i].amount.replace(/\./g, ''),
            amount2: array[i].amount2.replace(/\./g, ''),
            fee: array[i].fee.replace(/\./g, '')
          }
        } else {
          obj = {
            id: array[i].id,
            amount: array[i].amount.replace(/\./g, ''),
            amount2: array[i].amount2.replace(/\./g, ''),
            fee: array[i].fee.replace(/\./g, '')
          }
        }
        dataOmzet.push(obj)
      }
      var dataProduct = []
      var arr = this.comm.products
      for (let z = 0; z < arr.length; z++) {
        var obj2 = {}
        if (typeof arr[z].id === 'undefined') {
          obj2 = {
            commission_id: arr[z].commission_id,
            product_no: arr[z].product_no
          }
        } else {
          obj2 = {
            id: arr[z].id,
            commission_id: arr[z].commission_id,
            product_no: arr[z].product_no
          }
        }
        dataProduct.push(obj2)
      }
      var dataCustomer = []
      var arrc = this.comm.customers
      for (let a = 0; a < arrc.length; a++) {
        var obj3 = {}
        if (typeof arrc[a].id === 'undefined') {
          obj3 = {
            commission_id: arrc[a].commission_id,
            customer_no: arrc[a].customer_no,
            notes: arrc[a].notes
          }
        } else {
          obj3 = {
            id: arrc[a].id,
            commission_id: arrc[a].commission_id,
            customer_no: arrc[a].customer_no,
            notes: arrc[a].notes
          }
        }
        dataCustomer.push(obj3)
      }
      this.dataComm = {
        id: this.comm.id,
        name: this.comm.name,
        amount: this.comm.amount.replace(/\./g, ''),
        percentage: this.comm.percentage,
        percentage_age_limit: this.comm.percentage_age_limit,
        age: this.comm.age,
        age_limit: this.comm.age_limit,
        company_no: this.comm.company_no,
        notes: this.comm.notes,
        type: this.comm.type,
        active: this.comm.active,
        products: dataProduct,
        omzets: dataOmzet,
        customers: dataCustomer
      }
      console.log(this.dataComm)
      await axios.put(saleCommissionUrl + '/' + this.comm.id, this.dataComm, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
          this.$swal('Success', response.data.message, 'success')
          this.backParent()
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    }
  }
}
</script>
